// extracted by mini-css-extract-plugin
module.exports = {"content":"FingerprintModal_content__2szkI","dialog":"FingerprintModal_dialog__1J7w8","body":"FingerprintModal_body__2ISjA"};